if (!customElements.get('alwan-hero-video')) {
  customElements.define(
    'alwan-hero-video',
    class AlwanHeroVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.alwan-hero-video__toggle');
        if (!this.video || !this.toggle) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.saveData = Boolean(navigator.connection && navigator.connection.saveData);
        this.userPaused = false;
        this.visible = false;

        this.toggle.hidden = false;
        this.toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.userPaused = !this.video.paused;
          if (this.video.paused) this.play();
          else this.video.pause();
        });
        this.video.addEventListener('ended', () => this.onEnded());
        this.video.addEventListener('play', () => this.syncButton());
        this.video.addEventListener('pause', () => this.syncButton());

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.visible = entries.some((entry) => entry.isIntersecting);
            this.update();
          }, { threshold: 0.4 });
          this.observer.observe(this);
        }

        this.slide = this.closest('.item');
        if (this.slide) {
          this.slideObserver = new MutationObserver(() => this.update());
          this.slideObserver.observe(this.slide, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.slideObserver) this.slideObserver.disconnect();
      }

      slideIsActive() {
        if (!this.slide || !this.slide.classList.contains('slick-slide')) return true;
        return this.slide.classList.contains('slick-active') || this.slide.classList.contains('slick-current');
      }

      carousel() {
        if (!window.jQuery) return null;
        const slider = window.jQuery(this).closest('.slick-initialized');
        if (!slider.length || !slider.slick('slickGetOption', 'autoplay')) return null;
        return slider;
      }

      holdCarousel() {
        const slider = this.carousel();
        if (!slider) return;
        slider.slick('slickPause');
        this.video.loop = false;
        this.holding = slider;
      }

      releaseCarousel(advance) {
        const slider = this.holding;
        this.holding = null;
        this.video.loop = true;
        if (!slider) return;
        slider.slick('slickPlay');
        if (advance) slider.slick('slickNext');
      }

      onEnded() {
        if (this.holding) {
          this.releaseCarousel(true);
        } else {
          this.video.currentTime = 0;
          this.play();
        }
      }

      update() {
        const active = this.visible && this.slideIsActive();
        const shouldPlay = active && !this.userPaused && !this.reducedMotion.matches && !this.saveData;
        if (shouldPlay && this.video.paused) {
          this.video.currentTime = 0;
          this.holdCarousel();
          this.play();
        } else if (!shouldPlay && !this.video.paused) {
          this.video.pause();
        }
        if (!this.slideIsActive() && this.holding) this.releaseCarousel(false);
      }

      play() {
        const attempt = this.video.play();
        if (attempt && attempt.catch) attempt.catch(() => this.syncButton());
      }

      syncButton() {
        const playing = !this.video.paused;
        this.toggle.setAttribute('aria-pressed', String(playing));
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.labelPause : this.toggle.dataset.labelPlay);
      }
    }
  );
}
